
import { 
    EDIT_HOSPITAL,
    EDIT_HOSPITAL_SUCCESS,
    EDIT_HOSPITAL_FAIL, 
    EDIT_HOSPITAL_RESET,
} from "../actions/editHospitalAction";

const initialState = {
    apiState: "",
    message: "",
    data: null,
    error: "",
}

const editHospitalReducer = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_HOSPITAL:
            return {
                ...state,
                apiState: "loading",
            };
        case EDIT_HOSPITAL_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data,
                message: action.response.message ? action.response.message : "success",
            };
        case EDIT_HOSPITAL_FAIL:
            return {
                ...state,
                apiState: "error",
                error: action.response.errors,
                message: action.response.message ? action.response.message : "error",
            };
        case EDIT_HOSPITAL_RESET:
            return initialState;
        default: 
            return state;
    }
};

export default editHospitalReducer;
